import React from 'react';
import { OrderListItemInProductProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { Cell, CellsWrapper, Title, Wrapper } from './order-list-item-in-product.styles';
import { dateStart } from '@shared/lib/utils/date/date';
import { Tag } from '@shared/ui/tag/tag';
import { STATUS_MAP } from '@entities/order/config/ui-constants';

export const OrderListItemInProduct: React.FC<OrderListItemInProductProps> = ({ order, onClick }) => {
    const tag = STATUS_MAP[order.status];

    return (
        <Wrapper onClick={onClick}>
            <Title size='subtitle2'>{order.product.name}</Title>
            <CellsWrapper>
                <Cell>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата создания сделки
                    </Typography>
                    <Typography size='body2_long'>{dateStart(order.createdAt)}</Typography>
                </Cell>
                <Cell>
                    <Typography size='body2_long' color='neutral_50'>
                        Статус
                    </Typography>
                    <Tag variant={tag?.variant}>{tag?.children}</Tag>
                </Cell>
            </CellsWrapper>
        </Wrapper>
    );
};
